// B2 - Ünite 4: Passive Voice
// Hedef: Edilgen yapı: is served, was delayed, will be announced

export const B2_UNIT_4 = {
  'B2-U4-L1': {
    id: 'B2-U4-L1',
    title: 'Present Passive (is/are + V3)',
    type: 'lesson',
    content: {
      sections: [
        {
          type: 'grammar',
          title: '📚 Present Passive',
          explanation: 'Eylemi yapan değil, eyleme maruz kalan önemli olduğunda Passive kullanılır.',
          table: {
            headers: ['Active', 'Passive', 'Türkçesi'],
            rows: [
              ['We serve meals.', 'Meals are served.', 'Yemekler servis edilir.'],
              ['They check passports.', 'Passports are checked.', 'Pasaportlar kontrol edilir.'],
              ['The crew cleans the cabin.', 'The cabin is cleaned.', 'Kabin temizlenir.']
            ]
          }
        },
        {
          type: 'grammar',
          title: '✈️ Havacılık Örnekleri',
          table: {
            headers: ['Passive', 'Türkçesi'],
            rows: [
              ['Meals are served during the flight.', 'Uçuş sırasında yemekler servis edilir.'],
              ['Seatbelts are fastened before takeoff.', 'Kalkıştan önce kemerler bağlanır.'],
              ['Boarding passes are checked at the gate.', 'Biniş kartları kapıda kontrol edilir.'],
              ['Safety demonstrations are given before departure.', 'Kalkıştan önce güvenlik gösterileri yapılır.']
            ]
          }
        },
        {
          type: 'tip',
          content: '💡 Present Passive = am/is/are + V3 (past participle)'
        }
      ],
      exercises: [
        {
          type: 'multipleChoice',
          question: 'Meals _____ during the flight.',
          options: ['are served', 'is served', 'served', 'serves'],
          correct: 'are served',
          explanation: 'Meals (plural) → are + V3'
        },
        {
          type: 'multipleChoice',
          question: 'The cabin _____ before each flight.',
          options: ['is cleaned', 'are cleaned', 'cleaned', 'cleans'],
          correct: 'is cleaned',
          explanation: 'The cabin (singular) → is + V3'
        },
        {
          type: 'dragDrop',
          instruction: '🔀 Cümleyi doğru sıraya dizin',
          words: ['served', 'are', 'Meals', 'board', 'on'],
          correctOrder: [2, 1, 0, 4, 3],
          translation: 'Yemekler uçakta servis edilir.'
        },
        {
          type: 'flashcard',
          title: '🎴 Passive Kartları',
          cards: [
            { front: 'serve → is served', back: 'servis edilir' },
            { front: 'check → is checked', back: 'kontrol edilir' },
            { front: 'clean → is cleaned', back: 'temizlenir' },
            { front: 'announce → is announced', back: 'duyurulur' }
          ]
        }
      ]
    }
  },
  'B2-U4-L2': {
    id: 'B2-U4-L2',
    title: 'Past Passive (was/were + V3)',
    type: 'lesson',
    content: {
      sections: [
        {
          type: 'grammar',
          title: '📚 Past Passive',
          table: {
            headers: ['Active', 'Passive', 'Türkçesi'],
            rows: [
              ['They delayed the flight.', 'The flight was delayed.', 'Uçuş ertelendi.'],
              ['We served dinner.', 'Dinner was served.', 'Akşam yemeği servis edildi.'],
              ['They cancelled the flights.', 'The flights were cancelled.', 'Uçuşlar iptal edildi.']
            ]
          }
        },
        {
          type: 'grammar',
          title: '✈️ Havacılık Örnekleri',
          table: {
            headers: ['Passive', 'Türkçesi'],
            rows: [
              ['The flight was delayed due to bad weather.', 'Uçuş kötü hava nedeniyle ertelendi.'],
              ['All passengers were evacuated safely.', 'Tüm yolcular güvenli bir şekilde tahliye edildi.'],
              ['The announcement was made by the captain.', 'Anons kaptan tarafından yapıldı.'],
              ['Medical assistance was provided immediately.', 'Tıbbi yardım derhal sağlandı.']
            ]
          }
        },
        {
          type: 'tip',
          content: '💡 Past Passive = was/were + V3'
        }
      ],
      exercises: [
        {
          type: 'multipleChoice',
          question: 'The flight _____ due to fog.',
          options: ['was delayed', 'were delayed', 'delayed', 'is delayed'],
          correct: 'was delayed',
          explanation: 'The flight (singular) → was + V3'
        },
        {
          type: 'multipleChoice',
          question: 'All passengers _____ safely.',
          options: ['were evacuated', 'was evacuated', 'evacuated', 'are evacuated'],
          correct: 'were evacuated',
          explanation: 'Passengers (plural) → were + V3'
        },
        {
          type: 'timeRace',
          title: '⏱️ Was mı Were mı?',
          cards: [
            { front: 'The flight ___ delayed', back: 'was' },
            { front: 'The passengers ___ informed', back: 'were' },
            { front: 'Dinner ___ served', back: 'was' },
            { front: 'The bags ___ loaded', back: 'were' },
            { front: 'The announcement ___ made', back: 'was' },
            { front: 'All flights ___ cancelled', back: 'were' }
          ]
        }
      ]
    }
  },
  'B2-U4-L3': {
    id: 'B2-U4-L3',
    title: 'Future Passive (will be + V3)',
    type: 'lesson',
    content: {
      sections: [
        {
          type: 'grammar',
          title: '📚 Future Passive',
          table: {
            headers: ['Active', 'Passive', 'Türkçesi'],
            rows: [
              ['We will serve lunch.', 'Lunch will be served.', 'Öğle yemeği servis edilecek.'],
              ['They will announce the delay.', 'The delay will be announced.', 'Gecikme duyurulacak.'],
              ['We will provide assistance.', 'Assistance will be provided.', 'Yardım sağlanacak.']
            ]
          }
        },
        {
          type: 'grammar',
          title: '✈️ Anons Örnekleri',
          table: {
            headers: ['Anons', 'Türkçesi'],
            rows: [
              ['Lunch will be served shortly.', 'Öğle yemeği kısa süre içinde servis edilecek.'],
              ['The seatbelt sign will be turned off.', 'Kemer işareti kapatılacak.'],
              ['Boarding will be announced soon.', 'Biniş yakında duyurulacak.'],
              ['Your bags will be delivered to carousel 5.', 'Çantalarınız 5 numaralı banda teslim edilecek.']
            ]
          }
        },
        {
          type: 'tip',
          content: '💡 Future Passive = will be + V3'
        }
      ],
      exercises: [
        {
          type: 'multipleChoice',
          question: 'Lunch _____ shortly.',
          options: ['will be served', 'will served', 'is served', 'was served'],
          correct: 'will be served',
          explanation: 'Future Passive: will be + V3'
        },
        {
          type: 'fillInBlank',
          sentence: 'The announcement _____ (make) by the captain.',
          answer: 'will be made',
          hint: 'Future Passive: will be + V3'
        },
        {
          type: 'flashcard',
          title: '🎴 Future Passive Kartları',
          cards: [
            { front: 'will be served', back: 'servis edilecek' },
            { front: 'will be announced', back: 'duyurulacak' },
            { front: 'will be provided', back: 'sağlanacak' },
            { front: 'will be delivered', back: 'teslim edilecek' }
          ]
        }
      ]
    }
  },
  'B2-U4-L4': {
    id: 'B2-U4-L4',
    title: 'Passive with Modals',
    type: 'lesson',
    content: {
      sections: [
        {
          type: 'grammar',
          title: '📚 Modal + be + V3',
          table: {
            headers: ['Modal', 'Passive', 'Türkçesi'],
            rows: [
              ['can', 'can be done', 'yapılabilir'],
              ['must', 'must be done', 'yapılmalı'],
              ['should', 'should be done', 'yapılmalı'],
              ['may', 'may be done', 'yapılabilir'],
              ['has to', 'has to be done', 'yapılmak zorunda']
            ]
          }
        },
        {
          type: 'grammar',
          title: '✈️ Havacılık Örnekleri',
          table: {
            headers: ['Cümle', 'Türkçesi'],
            rows: [
              ['Seatbelts must be fastened.', 'Kemerler bağlanmalı.'],
              ['Electronic devices should be turned off.', 'Elektronik cihazlar kapatılmalı.'],
              ['Bags can be stored overhead.', 'Çantalar üst bine koyulabilir.'],
              ['Passports have to be shown.', 'Pasaportlar gösterilmek zorunda.']
            ]
          }
        },
        {
          type: 'tip',
          content: '💡 Modal Passive = modal + be + V3 (must be fastened, can be stored)'
        }
      ],
      exercises: [
        {
          type: 'multipleChoice',
          question: 'Seatbelts _____ during takeoff.',
          options: ['must be fastened', 'must fasten', 'must be fasten', 'must fastened'],
          correct: 'must be fastened',
          explanation: 'Modal Passive: must + be + V3'
        },
        {
          type: 'multipleChoice',
          question: 'Electronic devices _____ off.',
          options: ['should be turned', 'should turned', 'should be turn', 'should turn'],
          correct: 'should be turned',
          explanation: 'Modal Passive: should + be + V3'
        },
        {
          type: 'flashcard',
          title: '🎴 Modal Passive Kartları',
          cards: [
            { front: 'must be fastened', back: 'bağlanmalı' },
            { front: 'should be turned off', back: 'kapatılmalı' },
            { front: 'can be stored', back: 'saklanabilir' },
            { front: 'has to be shown', back: 'gösterilmeli' }
          ]
        }
      ]
    }
  },
  'B2-U4-L5': {
    id: 'B2-U4-L5',
    title: 'Uygulama: Prosedür Anlatımı',
    type: 'lesson',
    content: {
      sections: [
        {
          type: 'grammar',
          title: '📝 Güvenlik Prosedürü - Passive',
          table: {
            headers: ['Adım', 'Passive Cümle'],
            rows: [
              ['1', 'Boarding passes are checked at the gate.'],
              ['2', 'Carry-on bags are stored in the overhead compartments.'],
              ['3', 'Seatbelts must be fastened before takeoff.'],
              ['4', 'Safety demonstrations are given by the crew.'],
              ['5', 'Electronic devices should be turned off.']
            ]
          }
        },
        {
          type: 'vocabulary',
          title: '✈️ Anons Passive Cümleleri',
          words: [
            { en: 'Boarding will be announced shortly.', tr: 'Biniş kısa süre içinde duyurulacak.', pronunciation: '' },
            { en: 'Meals are being served now.', tr: 'Yemekler şu anda servis ediliyor.', pronunciation: '' },
            { en: 'The seatbelt sign has been turned on.', tr: 'Kemer işareti açıldı.', pronunciation: '' },
            { en: 'Your attention is required for safety.', tr: 'Güvenlik için dikkatiniz isteniyor.', pronunciation: '' }
          ]
        }
      ],
      exercises: [
        {
          type: 'speaking',
          instruction: 'Bu anonsları sesli okuyun:',
          phrases: [
            'Boarding will be announced shortly.',
            'Seatbelts must be fastened.',
            'Electronic devices should be turned off.',
            'Meals will be served after takeoff.'
          ]
        }
      ]
    }
  },
  'B2-U4-EXAM': {
    id: 'B2-U4-EXAM',
    title: 'Ünite 4 Sınavı',
    type: 'exam',
    exercises: [
      {
        type: 'multipleChoice',
        question: 'Meals _____ during the flight.',
        options: ['are served', 'is served', 'served', 'serves'],
        correct: 'are served',
        explanation: 'Present Passive: are + V3'
      },
      {
        type: 'multipleChoice',
        question: 'The flight _____ due to weather.',
        options: ['was delayed', 'were delayed', 'delayed', 'is delayed'],
        correct: 'was delayed',
        explanation: 'Past Passive: was + V3'
      },
      {
        type: 'multipleChoice',
        question: 'Lunch _____ shortly.',
        options: ['will be served', 'will served', 'is served', 'served'],
        correct: 'will be served',
        explanation: 'Future Passive: will be + V3'
      },
      {
        type: 'multipleChoice',
        question: 'Seatbelts _____ during takeoff.',
        options: ['must be fastened', 'must fasten', 'must be fasten', 'fastened'],
        correct: 'must be fastened',
        explanation: 'Modal Passive: must + be + V3'
      },
      {
        type: 'fillInBlank',
        sentence: 'The announcement _____ (make) by the captain.',
        answer: 'was made',
        hint: 'Past Passive: was + V3'
      },
      {
        type: 'matchPairs',
        instruction: 'Passive zamanları eşleştirin',
        pairs: [
          { left: 'Present Passive', right: 'is/are + V3' },
          { left: 'Past Passive', right: 'was/were + V3' },
          { left: 'Future Passive', right: 'will be + V3' },
          { left: 'Modal Passive', right: 'modal + be + V3' }
        ]
      }
    ]
  }
};

export default B2_UNIT_4;
